export default "__VITE_ASSET__Cpx51HTp__"